const ChartTypeEnum = Object.freeze({
	LINE: { apiName: "Line", chartName: "line" },
	BAR: { apiName: "Bar", chartName: "column" },
	BARH: { apiName: "BarH", chartName: "bar" },
	BARS: { apiName: "BarS", chartName: "column"},
	BARHS: { apiName: "BarHS", chartName: "bar" },
	MAP: {apiName: "Map", chartName: "map"},
	TREEMAP: { apiName: "Tree Map", chartName: "treemap" },
  SANKEY: { apiName: "Sankey", chartName: "sankey" },
	TABLE: { apiName: "Table", chartName: "table" },
  SOURCE: { apiName: "Source", chartName: "source" },
})

 /**
 * Get the HC value from API Name.
 * @param {string} apiName
 * @returns {string|null}
 */
function getchartNameFromApiName(apiName) {
  for (const key in ChartTypeEnum) {
    if (ChartTypeEnum[key].apiName === apiName) {
      return ChartTypeEnum[key].chartName;
    }
  }
  return null;
}

/**
 * Get the API Name from an HC value.
 * @param {string} apiValue
 * @returns {string|null}
 */
function getApiNameFromChartName(chartName) {
  for (const key in ChartTypeEnum) {
    if (ChartTypeEnum[key].chartName === chartName) {
      return ChartTypeEnum[key].apiName;
    }
  }
  return null;
}

export { ChartTypeEnum, getchartNameFromApiName, getApiNameFromChartName };
